import React from 'react'

import { Link, useNavigate } from 'react-router-dom'
import '../Style.css'

export const SuccessPageWithdrawal = () => {

    const navigate = useNavigate()

    setTimeout(()=>{
        navigate('/wallet',{replace: true})
    },3000)

  return (
    <div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <div className="message-box _success">
                        <i className="fa fa-check-circle" aria-hidden="true"></i>
                        <h2> Your Withdrawal placed successfully </h2>
                    {/* <p> Thank you for your payment. we will <br>
    be in contact with more details shortly </p>       */}
                        <Link to={'/wallet'} >wallet</Link>
                    </div> 
                </div> 
            </div> 
        </div>
    </div>
  )
}
